import * as React from 'react';
import {
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid2';


interface UserHeaderProps {
  selectedUser?: User;
  selectedSiteName?: string;
  selectedStorageName?: string;
  onHomeClick?: () => void;
  onSiteNameClick?: () => void;
}

const UserHeader: React.FC<UserHeaderProps> = ({
  selectedUser,
  selectedSiteName,
  selectedStorageName,
  onHomeClick,
  onSiteNameClick,
}) => {
  const theme = useTheme();

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Grid
            container
            alignItems="center"
            sx={{
                backgroundColor: theme.palette.headerBackground,
                px: 2,
                height: 50,
                borderBottom: theme.palette.border,
            }}
        >
            <IconButton
              aria-label="Go to all sites"
              size="small"
              onClick={onHomeClick}
              sx={{ mr: 1 }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 21V9L12 3L20 9V21H14V14H10V21H4Z" fill="#1F9122" />
              </svg>
            </IconButton>
            <Typography sx={{ mr: 1, ...theme.typography.usersFontTitle }}>/</Typography>
            {selectedSiteName && (
              <Typography
                  onClick={onSiteNameClick}
                  sx={{
                  mr: 1,
                  ...theme.typography.usersFontTitle,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '300px',
                  cursor: onSiteNameClick ? 'pointer' : 'default',
                  textDecoration: onSiteNameClick ? 'underline' : 'none',
                }}
              >
                {selectedSiteName}
              </Typography>
            )}
            {selectedStorageName && (
              <>
                <Typography sx={{ mr: 1, ...theme.typography.usersFontTitle }}>/</Typography>
                <Typography
                  sx={{
                    mr: 1,
                    ...theme.typography.usersFontTitle,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '300px',
                  }}
                >
                  {selectedStorageName}
                </Typography>
              </>
            )}
            {selectedUser && (
              <>
                <Typography
                  variant="h6"
                  sx={{
                    ...theme.typography.usersFontTitle,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '300px', // Added a maxWidth to ensure truncation happens
                  }}
                >
                  {selectedUser.email}
                </Typography>
              </>
            )}
        </Grid>
    </Grid>
    </>
  );
};

export default UserHeader;
